import { forwardRef, type ButtonHTMLAttributes } from 'react'
import { cn } from '@/lib/cn'

/**
 * SKILL §7: buzuvchi tugma hech qachon oddiy tugma ko'rinishida bo'lmaydi.
 * `danger` / `critical` variantlari vizual og'irligi bilan ajralib turadi.
 */
export type ButtonVariant =
  | 'default' // neytral, chegarali
  | 'primary' // asosiy harakat
  | 'danger' // buzuvchi (X2 daraja 3–4)
  | 'critical' // qaytarib bo'lmaydigan (X2 daraja 5)
  | 'ghost' // fon yo'q, ikonka tugmalari
  | 'warning' // X2 daraja 2

export type ButtonSize = 'sm' | 'md' | 'lg' | 'icon'

const VARIANTS: Record<ButtonVariant, string> = {
  default:
    'bg-surface-2 text-primary border border-border-default hover:bg-surface-3 hover:border-border-strong',
  primary: 'bg-accent text-accent-fg border border-transparent hover:bg-accent-hover',
  warning:
    'bg-transparent text-warning border border-warning hover:bg-warning-subtle',
  danger: 'bg-danger text-white border border-transparent hover:brightness-110',
  // Daraja 5 — shtrixli chegara, boshqa hech qayerda ishlatilmaydi.
  critical:
    'bg-critical text-white border-2 border-dashed border-critical hover:brightness-110',
  ghost: 'bg-transparent text-secondary border border-transparent hover:bg-surface-3 hover:text-primary',
}

const SIZES: Record<ButtonSize, string> = {
  sm: 'h-7 px-2.5 text-xs gap-1.5',
  md: 'h-8 px-3 text-sm gap-2',
  lg: 'h-9 px-4 text-base gap-2',
  icon: 'h-8 w-8 p-0 justify-center',
}

export interface ButtonProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: ButtonVariant
  size?: ButtonSize
}

export const Button = forwardRef<HTMLButtonElement, ButtonProps>(function Button(
  { className, variant = 'default', size = 'md', type = 'button', ...props },
  ref,
) {
  return (
    <button
      ref={ref}
      type={type}
      className={cn(
        'inline-flex items-center rounded-md font-medium whitespace-nowrap select-none',
        'transition-colors duration-100',
        'disabled:opacity-45 disabled:pointer-events-none',
        VARIANTS[variant],
        SIZES[size],
        className,
      )}
      {...props}
    />
  )
})
